// Quest registry — the single list of quests in the world, mirroring npc/roster.ts.
// Both client (src/quest.ts state + journal HUD) and the server (index.ts) import this
// to resolve a quest id to its definition. Quests are CONTENT: authored as JSON in
// content/quests/*.json, validated + hydrated by src/content/load.ts. Add a quest =
// a JSON file + `bun run gen` (see content/SCHEMA.md) — no code edits.
import type { QuestSpec } from "./define.ts";
import { loadedQuests } from "../content/load.ts";

export const QUESTS: QuestSpec[] = loadedQuests;

/** The post-intro tutorial quest (Corin → Dekkar at the dock). Granted on every
 *  new character and ensured at join if missing — so the journal always opens
 *  with "talk to Dekkar" after the boat-arrival cinematic. */
export const STARTER_QUEST_ID = "soft-landing";

/** Find a quest by id (linear scan — the list is tiny). */
export function questById(id: string): QuestSpec | undefined {
  return QUESTS.find((q) => q.id === id);
}
